<script>
export default {
  name: "PresentationList",
  methods: {
    fileDelete(url) {
      window.location = url
    },
    inputFileChange(ref) {
      let files = this.$refs["file_input_" + ref].files
      if (files.length > 0) {
        this.$refs["file_form_" + ref].submit()
      }
    },
    fileUpload(ref) {
      this.$refs["file_input_" + ref].click()
    },
  },
}
</script>
